import { LocationType } from 'app/shared/features/location-selector/models/location-type';
import { LocationsModel } from 'app/shared/features/location-selector/models/server/locations-model';

export interface Locations {
    name: string;
    number: number;
    locationType: LocationType;
}

export function mapModelToLocations(model: LocationsModel): Locations {
    return {
        name: model.shortName?.trim() || model.name?.trim() || model.number.toString(),
        number: model.number,
        locationType: model.locationType,
    };
}
